import { useEffect, useMemo, useState } from "react";

import { useRouter } from "next/router";

import addKeyTermsToContentText from "@/view/utils/addKeyTermsToContentText/addKeyTermsToContentText";
import extractKeyTerms from "@/view/utils/extractKeyTerms";
import useLazyKeyTermsGet from "@/view/utils/useLazyKeyTermsGet";

const useKeyTerms = (initialRawText, isVocabularySupportEnabled) => {
  const router = useRouter();
  const { query } = router;
  const { contentId, levelId } = query;

  const [keyTermData, setKeyTermData] = useState({});
  const [fetchKeyTerms] = useLazyKeyTermsGet();

  const handleKeyTermData = async () => {
    const { data: termData } = await fetchKeyTerms({
      contentId,
      levelId,
      skip: !isVocabularySupportEnabled,
    });

    if (termData !== undefined) {
      setKeyTermData(termData);
    }
  };

  useEffect(() => {
    isVocabularySupportEnabled && handleKeyTermData();
  }, [contentId, isVocabularySupportEnabled, levelId]);

  const rawText = useMemo(() => {
    if (!initialRawText) return;

    const textObj = JSON.parse(JSON.stringify(initialRawText));
    const extractedKeyTerms = extractKeyTerms(keyTermData?.algorithm_output);
    const updatedText = addKeyTermsToContentText(
      { ...textObj },
      extractedKeyTerms,
    );

    return !updatedText?.content || !isVocabularySupportEnabled
      ? initialRawText
      : updatedText;
  }, [
    isVocabularySupportEnabled,
    JSON.stringify(initialRawText),
    JSON.stringify(keyTermData),
  ]);

  return { keyTermData, rawText };
};

export default useKeyTerms;
